/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import PreviewImage from './PreviewImage'
import PreviewDocuments from './PreviewDocuments'
import PreviewDocx from './PreviewDocx'
import PreviewPlayer from './PreviewPlayer'

import {
  WHITE_LIST_MIME_IMAGE,
  WHITE_LIST_MIME_AUDIO,
  WHITE_LIST_MIME_VIDEO,

  WHITE_LIST_MIME_FILE_DOCS,
  WHITE_LIST_MIME_FILE_PRESENTATION,
  WHITE_LIST_MIME_FILE_SHEET,

  WHITE_LIST_MIME_FILE_TEXT,
  WHITE_LIST_MIME_PDF,
  WHITE_LIST_MIME_CODE,

  WHITE_LIST_MIME_FILE_ARCHIVE
} from '../../../utils/mimetype'
import DialogCustom from '../Dialog'
import useUpload from '../../../hooks/upload/useUpload'

/**
 *  This component generate Dialog for show Preview Files uploaded according mimetype
 * @param {Object} 
 *   * @param {Boolean}   show - Open dialog
 *   * @param {Function}  onClose - Action for Close dialog
 *   * @param {Object}    data - Data of file
 *   * @param {Number}    height - height dialog
 *   * @param {Number}    width - width dialog
 */
const DialogPreviewFile = ({ show, onClose, data, width, height }) => {
  const label = data.description ? data.description : data.detail

  useEffect(() => {
    if (WHITE_LIST_MIME_FILE_ARCHIVE.includes(data.mimetype)) {
      onClose()
    }
  }, [data.mimetype])
  const {
    srcFile
  } = useUpload()

  return (
    <DialogCustom 
      id='box-media'
      show={show}
      headerModule={false}
      onClose={onClose} 
      onCloseHeader={onClose} 
      resizable={true} 
      width={width} 
      height={height}
      title={label}
    >
        { WHITE_LIST_MIME_IMAGE.includes(data.mimetype) &&
          <PreviewImage 
            data={data}
            src={srcFile(data.link)}
          />
        }
        { [...WHITE_LIST_MIME_AUDIO, ...WHITE_LIST_MIME_VIDEO].includes(data.mimetype) &&
          <PreviewPlayer
            url={srcFile(data.link)}
          />        
        }
        {  [...WHITE_LIST_MIME_FILE_DOCS, ...WHITE_LIST_MIME_FILE_PRESENTATION, ...WHITE_LIST_MIME_FILE_SHEET].includes(data.mimetype) && !data.file &&
          <PreviewDocuments
            type='microsoft'
            source={srcFile(data.link)}
            title={label}
          />        
        }
        { [...WHITE_LIST_MIME_PDF, ...WHITE_LIST_MIME_FILE_TEXT, ...WHITE_LIST_MIME_CODE, 'text/csv'].includes(data.mimetype) && !data.file &&
          <PreviewDocuments
            type='google'
            source={srcFile(data.link)}
            title={label}
          />        
        }     
        { [...WHITE_LIST_MIME_FILE_TEXT, ...WHITE_LIST_MIME_CODE].includes(data.mimetype) && data.file &&
          <PreviewDocuments
            type='local'
            source={srcFile(data.link)}
            title={label}
          />        
        }    
        
        { WHITE_LIST_MIME_PDF.includes(data.mimetype) && data.file &&
          <PreviewDocuments
            type='local'
            source={srcFile(data.link)}
            title={label}
          />        
        }   

        { WHITE_LIST_MIME_FILE_DOCS.includes(data.mimetype) && data.file &&
          <PreviewDocx
            data={data}
          />        
        }  
    </DialogCustom>
  )
}
export default DialogPreviewFile